// Giờ mở cửa trạm: chuẩn hoá chữ tự do cũ ("8 AM", "6.30 am", "12: 00 AM", "24/7") về "HH:MM" cho ô chọn giờ.
// Quân chốt 26/10/2026: ô giờ trong Admin đổi từ gõ chữ sang chọn giờ để hết kiểu viết lộn xộn.

/** Chữ giờ bất kỳ → "HH:MM" (24 giờ); không đọc được ⇒ "". "24/7" ⇒ "" (để ô tick 24h xử lý). */
export function toHHMM(text: unknown): string {
	const s = String(text ?? "").trim().toLowerCase().replace(/\s+/g, "");
	const m = s.match(/^(\d{1,2})(?:[:.](\d{2}))?(am|pm)?$/);
	if (!m) return "";
	let h = Number(m[1]);
	const min = Number(m[2] || 0);
	if (m[3] === "pm" && h < 12) h += 12;
	if (m[3] === "am" && h === 12) h = 0;
	if (h === 24 && min === 0) return "23:59";
	if (h > 23 || min > 59) return "";
	return `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
}

/** Giờ đang lưu → cặp giá trị cho form. "24/7" hoặc 00:00–23:59/24:00 ⇒ 00:00–23:59 (ô tick 24h). */
export function workTimeForForm(from: unknown, to: unknown): { from: string; to: string } {
	const raw = `${from ?? ""} ${to ?? ""}`;
	if (/24\s*\/\s*7/.test(raw)) return { from: "00:00", to: "23:59" };
	const f = toHHMM(from);
	const t = toHHMM(to);
	if (f === "00:00" && (t === "23:59" || t === "00:00")) return { from: "00:00", to: "23:59" };
	return { from: f, to: t };
}
